function brochureLocal() {
  window.removeVoidLink = function (widgetName) {
    const cards = $(`#${widgetName} .card-widget-item`);
    cards.each(function () {
      const card = $(this);
      const cardLinkHref = card.attr('href');
      // check if the cardLink contain
      if (cardLinkHref.includes('void')) {
        card.removeAttr('href');
      }
    });
  };

  const bodyBigELanding = $('body').hasClass('bigELanding');
  const contentBigELanding = $('.bigELanding .content');
  const widgetsLayoutBigELanding = contentBigELanding.find('.endOfContent');

  if (bodyBigELanding) {
    $('.bigELanding .wrapper').find('.afterContent').remove();
    contentBigELanding.children().not(widgetsLayoutBigELanding).remove();
    // append the content of .endOfContent to contentBigELanding
    contentBigELanding.append(widgetsLayoutBigELanding.children());
    // remove .endOfContent
    widgetsLayoutBigELanding.remove();
  } else {
    $('.endOfContent').remove();
  }
}

export { brochureLocal };
